<template>
  <f7-page no-swipeback ref="page">
    <f7-navbar title="歷史訂單" back-link="返回"></f7-navbar>
    
    <div>
      <f7-list inline-labels no-hairlines-md style="margin: 10px 0">
        <f7-list-item>
          <f7-input
            type="select"
            placeholder="選擇店舖"
            @input="onStoreChange"
            :value="selectedStoreId"
          >
            <option value="">全部店舖 All Stores</option>
            <option v-for="store in stores" :value="store.id" :key="store.id">{{ store.name }}</option>
          </f7-input>
        </f7-list-item>
      </f7-list>
    </div>
    <f7-list media-list ref="list">
      <f7-list-item
        v-for="order in data.data"
        :link="`/store/order/${order.id}/`"
        :key="order.id"
        :title="`#${order.id} - 訂單 ${order.created_at}`"
        :after="order.status"
        :subtitle="order.description"
        :text="order.user_name"
        :footer="order.store_name"
      ></f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
import axios from 'axios'
import { format, parseISO } from 'date-fns'

export default {
  mounted() {
    this.fetchStores()
    this.fetchOrders()
  },

  data() {
    return {
      data: [],
      stores: [],
      selectedStoreId: ''
    }
  },

  methods: {
    fetchStores() {
      axios.get('/api/stores').then(({ data }) => {
        this.stores = data.data
      })
    },

    fetchOrders() {
      const params = {}
      if (this.selectedStoreId) {
        params.store_id = this.selectedStoreId
      }

      axios.get('/api/orders', { params }).then(({ data }) => {
        for (let i = 0; i < data.data.length; i++) {
          data.data[i].created_at = format(parseISO(data.data[i].created_at), 'yyyy-MM-dd HH:mm')
          data.data[i].description = `${parseFloat(data.data[i].total_quantity)} 件商品，合共 $${Math.round((data.data[i].total / 100) * 10) / 10}`
        }

        this.data = data
      })
    },

    onStoreChange(event) {
      this.selectedStoreId = event.target.value
      this.fetchOrders()
    }
  }
}
</script>
